export default __webpack_public_path__ + "static/media/signInInstructions.8cff74ae.png";